module.exports = __webpack_public_path__ + "img/59400.1871a686.jpg";